module.exports = __webpack_public_path__ + "static/media/ic-heart.2de6b0d1.svg";